import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Item, toItemXml } from '../../dataObjects/Item';

export interface IUpdateItemRequest extends IBaseRequest {
    ITEM: Item;
}

export class UpdateItemRequest extends BaseRequest implements IUpdateItemRequest {
    public ITEM: Item;

  constructor(server: string, session: string, item: Item) {
    super(server, session);
    this.ITEM = item;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += toItemXml(this.ITEM);

    return super.wrapperXml('UpdateItem', parameters);
  }
}
